export enum IntercomCustomEventType {
  SocialConnected = 'Social Connected',
  ProfileBrandingSet = 'Profile: Branding set',
  MyMarketSet = 'Profile: My Market set',
  ProfileSocialLinksSet = 'Profile: Social links set',
}
